/**
 * Free Sample Product Handler
 * 
 * This script automatically adds a free sample product to the cart when customers add items
 * and increases the quantity of the free sample when more products are added.
 */

(function() {
  // Configuration
  const config = {
    freeSampleProductId: 'luxe-aoud-2ml', // Change this to your free sample product ID/handle
    freeSampleVariantId: null, // Will be populated from the API
    maxSampleQuantity: 5, // Maximum number of free samples allowed
    sampleToProductRatio: 1, // 1 free sample per regular product
    freeSampleProperties: { // Custom properties to identify the free sample
      '_free_sample': 'true',
      '_auto_added': 'true'
    }
  };

  // Initialize by fetching the free sample variant ID
  function initFreeSample() {
    fetch(`/products/${config.freeSampleProductId}.js`)
      .then(response => {
        if (!response.ok) {
          throw new Error(`Product not found: ${response.status}`);
        }
        return response.json();
      })
      .then(product => {
        if (product && product.variants && product.variants.length > 0) {
          config.freeSampleVariantId = product.variants[0].id;
          console.log('Free sample variant ID:', config.freeSampleVariantId);
        } else {
          console.error('Could not find free sample product variant');
        }
      })
      .catch(error => {
        console.error('Error fetching free sample product:', error);
        // Disable free sample functionality if product doesn't exist
        if (error.message && error.message.includes('404')) {
          console.log('Free sample product not found. Disabling free sample functionality.');
          // Disable the free sample functionality
          config.maxSampleQuantity = 0;
          config.sampleToProductRatio = 0;
          // Prevent any reloads on cart page
          if (window.location.pathname === '/cart') {
            window.freeSampleRefreshing = true;
          }
        }
      });
  }

  // Listen for product added to cart event
  document.addEventListener('product:added', handleProductAdded);
  
  // Handle product added event
  function handleProductAdded(event) {
    if (!config.freeSampleVariantId) {
      console.warn('Free sample variant ID not yet initialized');
      return;
    }
    
    // Get current cart state
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        updateFreeSample(cart);
      })
      .catch(error => console.error('Error fetching cart:', error));
  }
  
  // Update free sample in cart based on regular product count
  function updateFreeSample(cart) {
    // Count regular products (excluding the free sample)
    const regularProducts = cart.items.filter(item => {
      // Check if item has free sample properties
      const isFreeItem = item.properties && 
                         item.properties._free_sample === 'true';
      
      return !isFreeItem && item.variant_id !== config.freeSampleVariantId;
    });
    
    const regularProductCount = regularProducts.reduce((total, item) => total + item.quantity, 0);
    
    // Find free sample in cart (check by variant ID and properties)
    const freeSample = cart.items.find(item => 
      item.variant_id === config.freeSampleVariantId || 
      (item.properties && item.properties._free_sample === 'true')
    );
    
    const currentSampleQuantity = freeSample ? freeSample.quantity : 0;
    
    // Calculate desired sample quantity based on ratio (capped at maximum)
    const desiredSampleQuantity = Math.min(
      Math.floor(regularProductCount * config.sampleToProductRatio), 
      config.maxSampleQuantity
    );
    
    // Update free sample quantity if needed
    if (desiredSampleQuantity > currentSampleQuantity) {
      // Add or update free sample
      const updates = {
        id: config.freeSampleVariantId,
        quantity: desiredSampleQuantity,
        properties: config.freeSampleProperties
      };
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      })
      .then(response => response.json())
      .then(data => {
        console.log(`Updated free sample quantity to ${desiredSampleQuantity}`);
        
        // Update the UI if we're on the cart page
        if (window.location.pathname === '/cart') {
          // Use a longer delay (1 minute) to allow Shopify to update the cart
          setTimeout(() => {
            // Add a flag to prevent infinite refresh loops
            if (!window.freeSampleRefreshing) {
              window.freeSampleRefreshing = true;
              console.log('Refreshing cart page after free sample update');
              window.location.reload();
            } else {
              console.log('Prevented cart refresh - already refreshing');
            }
          }, 60000); // Increased to 1 minute (60000ms)
        }
      })
      .catch(error => console.error('Error updating free sample:', error));
    } else if (regularProductCount === 0 && currentSampleQuantity > 0) {
      // If there are no regular products but we have samples, remove them
      const updates = {
        updates: {
          [freeSample.id]: 0
        }
      };
      
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      })
      .then(() => {
        if (window.location.pathname === '/cart') {
          // Add a flag to prevent infinite refresh loops
          if (!window.freeSampleRefreshing) {
            window.freeSampleRefreshing = true;
            console.log('Refreshing cart page after removing free sample');
            window.location.reload();
          } else {
            console.log('Prevented cart refresh - already refreshing');
          }
        }
      })
      .catch(error => console.error('Error removing free sample:', error));
    }
  }

  // Listen for cart drawer open
  document.addEventListener('cart:open', function() {
    // When cart drawer opens, check if we need to update free samples
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => updateFreeSample(cart))
      .catch(error => console.error('Error updating free samples on cart open:', error));
  });
  
  // Listen for cart update events
  document.addEventListener('cart:refresh', function(event) {
    // When cart is refreshed, check if we need to update free samples
    if (event.detail && event.detail.cart) {
      updateFreeSample(event.detail.cart);
    } else {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => updateFreeSample(cart))
        .catch(error => console.error('Error updating free samples on cart refresh:', error));
    }
  });
  
  // Initialize on DOM content loaded
  document.addEventListener('DOMContentLoaded', function() {
    // Check if we've already refreshed once
    const hasRefreshed = sessionStorage.getItem('cartRefreshed');
    
    // Reset refresh flag on page load
    if (hasRefreshed && window.location.pathname === '/cart') {
      console.log('Cart already refreshed in this session, preventing further refreshes');
      window.freeSampleRefreshing = true;
    } else {
      window.freeSampleRefreshing = false;
      
      // If we're on the cart page, mark that we've refreshed
      if (window.location.pathname === '/cart') {
        sessionStorage.setItem('cartRefreshed', 'true');
      }
    }
    
    initFreeSample();
    
    // Also check cart on page load to ensure free samples are correct
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Small delay to ensure variant ID is fetched
        setTimeout(() => {
          // Only update if we haven't already refreshed
          if (!window.freeSampleRefreshing) {
            updateFreeSample(cart);
          } else {
            console.log('Skipping free sample update to prevent refresh');
          }
        }, 500);
      })
      .catch(error => console.error('Error fetching cart on init:', error));
  });
})(); 